import { AxiosClient } from '@/app/shared/services';

const state = {
    unit_economics: {}
};

const getters = {
    GET_ECONOMICS: state => state.unit_economics,
};

const mutations = {
};

const actions = {
    GET_ECONOMICS: (context, params) => new Promise((resolve, reject) => {
        AxiosClient.post('/uniteconomics/get_users', params)
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    }),
    GET_UTM_SOURCES: (context, params) => new Promise((resolve, reject) => {
        AxiosClient.get('/uniteconomics/get_utm_sources', { params })
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    }),
    GET_CURRENCY_LIST: (context, params) => new Promise((resolve, reject) => {
        AxiosClient.get('/uniteconomics/get_currencys')
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    }),
};

export default {
    state,
    getters,
    mutations,
    actions,
};
